import React from "react";
import "../style/page/Terms.css";
import { useTranslation } from "../contexts/TranslationContext";
import { useTermsContent } from "../hooks/useTermsContent";

function Terms() {
  const { t } = useTranslation();
  const { content } = useTermsContent();

  return (
    <main className="terms-content">
      <div className="container">
        {/* Simple Document Header */}
        <div className="terms-header">
          <h1 className="terms-title">{t("terms.mainTitle")}</h1>
          <h2 className="terms-brand">VietQubit</h2>
          <p className="terms-date">{t("terms.lastUpdate")}</p>
        </div>

        {/* Terms Content Body */}
        <div className="terms-body" id="terms-content" dangerouslySetInnerHTML={{ __html: content }} />

        {/* Simple Conclusion */}
        <div className="terms-conclusion">
          <h3>{t("terms.conclusionTitle")}</h3>
          <p>{t("terms.conclusion")}</p>
          <ul className="conclusion-list">
            <li>{t("terms.conclusion1")}</li>
            <li>{t("terms.conclusion2")}</li>
            <li>{t("terms.conclusion3")}</li>
            <li>{t("terms.conclusion4")}</li>
          </ul>
          <p className="validity-note">{t("terms.validity")}</p>

          {/* Document Meta Information */}
          <div className="terms-meta">
            <p>{t("terms.brandtagline")}</p>
            <p className="version-info">
              <span>{t("terms.version")}</span>
              <br />
              <span>{t("terms.originalLang")}</span>
              <br />
              <span>{t("terms.otherLang")}</span>
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Terms;
